<!--
 * @Description: 
 * @Date: 2019-07-31 16:11:15
 -->
<template>
  <el-breadcrumb separator-class="el-icon-arrow-right">
    <transition-group name="breadcrumb">
      <template v-for="(item, index) in breadcrumbList">
        <el-breadcrumb-item
          :key="index"
          v-if="item.name"
          :to="item.needQuery ?{ path: item.path,query:item.query}:{ path: item.path}"
        >{{item.name}}</el-breadcrumb-item>
      </template>
    </transition-group>
  </el-breadcrumb>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
export default {
  data() {
    return {
      // breadcrumbList: []
    };
  },
  methods: {
    ...mapMutations(['SET_BREADCRUMB']),
    init() {}
  },
  computed: {
    ...mapState({
      breadcrumbList: state => state.breadcrumb.breadcrumbList
    })
  },
  watch: {
    $route(to) {
      // if (to.meta.selfName) {
      //     this.SET_BREADCRUMB(to)
      // }
    }
  },
  components: {},
  created() {}
};
</script>
<style lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 10px;
  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
/*fade*/

.breadcrumb-enter-active,
.breadcrumb-leave-active {
  transition: all 0.5s;
}

.breadcrumb-enter,
.breadcrumb-leave-active {
  opacity: 0;
  transform: translateX(20px);
}

.breadcrumb-move {
  transition: all 0.5s;
}

.breadcrumb-leave-active {
  position: absolute;
}
</style>
